export const removeFromSessionStorage = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    console.log(`${key} removing from local storage error: `, err);
  }
};

export const saveToSessionStorage = (key, data) => {
  try {
    const dataJSON = JSON.stringify(data);

    sessionStorage.setItem(key, dataJSON);
  } catch (err) {
    console.log(`${key} saving to local storage error: `, err);
  }
};

export const getFromSessionStorage = (key) => {
  try {
    const data = sessionStorage.getItem(key);

    return data ? JSON.parse(data) : '';
  } catch (err) {
    console.log(`${key} getting from local storage error: `, err);
  }
};

export const clearLSessionStorage = () => {
  try {
    sessionStorage.clear();
  } catch (err) {
    console.log("Clearing local storage error: ", err);
  }
};
